<div class="flex justify-end gap-2 mb-5">
  <p-button
    (click)="onRowCreateInit()"
    [label]="'routeSection.add' | translate"
  />
</div>
<p-table
  #sectionsTable
  [value]="displaySections()"
  stripedRows
  showGridlines
  dataKey="id"
  [resizableColumns]="true"
  columnResizeMode="expand"
  [scrollable]="true"
  [loading]="false"
  [tableStyle]="{ 'min-width': '30rem' }"
  editMode="row"
  (onRowReorder)="onRowReorder($event)"
>
  <ng-template #header>
    <tr>
      <th style="width: 3rem"></th>
      @for (column of routeSectionColumns; track $index) {
        <th pResizableColumn>
          {{ column.header | translate }}
        </th>
      }
      <th></th>
    </tr>
  </ng-template>
  <ng-template #body let-section let-editing="editing" let-i="rowIndex">
    <tr [pEditableRow]="section" [pReorderableRow]="i">
      <td>
        <span pReorderableRowHandle>
          <i class="fa fa-bars"></i>
        </span>
      </td>
      <td>
        @if (newRowTrackingKeys().has(section.id)) {
          <span class="text-gray-400 italic">{{
            'routeSection.idAutoGenerated' | translate
          }}</span>
        } @else {
          {{ section.id }}
        }
      </td>
      <td>
        <p-cellEditor>
          <ng-template #input>
            <input
              pInputText
              type="text"
              [(ngModel)]="section.name"
              [ngClass]="{
                'ng-invalid ng-dirty': invalidFieldsMap()
                  .get(section.id)
                  ?.has('name'),
              }"
            />
          </ng-template>
          <ng-template #output>
            {{ section.name }}
          </ng-template>
        </p-cellEditor>
      </td>
      <td>
        <p-cellEditor>
          <ng-template #input>
            <p-select
              [options]="typeOptions"
              [(ngModel)]="section.type"
              optionLabel="label"
              optionValue="value"
              appendTo="body"
              [ngClass]="{
                'ng-invalid ng-dirty': invalidFieldsMap()
                  .get(section.id)
                  ?.has('type'),
              }"
            />
          </ng-template>
          <ng-template #output>
            {{
              section.type === 'element'
                ? ('routeSection.typeElement' | translate)
                : ('routeSection.typePlatform' | translate)
            }}
          </ng-template>
        </p-cellEditor>
      </td>
      <td>
        {{
          section.last_checked_at
            ? (section.last_checked_at | date: 'dd.MM.yyyy HH:mm' : 'Europe/Berlin')
            : '-'
        }}
      </td>
      <td>
        <div class="flex items-center justify-start gap-2">
          @if (editing) {
            <button
              pButton
              type="button"
              icon="fa fa-floppy-disk"
              (click)="onRowEditSave(section)"
              text
              rounded
              severity="success"
              [pTooltip]="'label.save' | translate"
              tooltipPosition="top"
            ></button>
            <button
              pButton
              type="button"
              pCancelEditableRow
              icon="fa fa-times"
              (click)="onRowEditCancel(section)"
              text
              rounded
              severity="danger"
              [pTooltip]="'label.cancel' | translate"
              tooltipPosition="top"
            ></button>
          } @else {
            <button
              pButton
              type="button"
              pInitEditableRow
              icon="fa fa-pencil"
              (click)="onRowEditInit(section)"
              text
              rounded
              severity="secondary"
              [pTooltip]="'label.edit' | translate"
              tooltipPosition="top"
            ></button>
            <button
              pButton
              type="button"
              icon="fa fa-triangle-exclamation"
              (click)="navigateToCreateDefect(section)"
              text
              rounded
              severity="warn"
              [pTooltip]="'routeSection.reportDefect' | translate"
              tooltipPosition="top"
            ></button>
            <button
              pButton
              type="button"
              icon="fa fa-clock-rotate-left"
              (click)="navigateToDefects(section)"
              [disabled]="!section.has_defects"
              text
              rounded
              severity="secondary"
              [pTooltip]="'routeSection.defectHistory' | translate"
              tooltipPosition="top"
            ></button>
            <button
              pButton
              type="button"
              icon="fa fa-clipboard-list"
              (click)="navigateToInspections(section)"
              text
              rounded
              severity="secondary"
              [pTooltip]="'routeSection.inspectionHistory' | translate"
              tooltipPosition="top"
            ></button>
            <button
              pButton
              type="button"
              icon="fa fa-trash"
              (click)="onRowDeleteInit($event, section)"
              text
              rounded
              severity="secondary"
              [pTooltip]="'label.delete' | translate"
              tooltipPosition="top"
            ></button>
          }
        </div>
      </td>
    </tr>
  </ng-template>
</p-table>
